import { Component, For, onCleanup } from 'solid-js';
import { createStore } from 'solid-js/store';
import { Portal } from 'solid-js/web';
import { Alert } from '@tcweb/connect-ui';
import { t } from '@trimble/i18n';
import {
  AppNotification,
  NotificationDelayLength,
  NotificationEventBus,
} from './notification-event-bus';

type NotificationWithId = AppNotification & { id: number };
const defaultNotificationDelay = 15000;
const delayMap: Record<NotificationDelayLength, number> = {
  short: 3000,
  medium: 8000,
  long: 15000,
};

const iconMap = {
  default: 'tc-icon-info',
  info: 'tc-icon-info',
  warning: 'tc-icon-warning',
  error: 'tc-icon-error',
};

export const Notifications: Component = () => {
  const [notifications, setNotifications] = createStore<NotificationWithId[]>(
    []
  );
  let notificationId = 1;

  const off = NotificationEventBus.listen((notification: AppNotification) => {
    const id = notificationId++;
    setNotifications((prev) => [...prev, { id, ...notification }]);

    setTimeout(
      () => {
        removeNotification(id);
      },
      notification.delay == undefined
        ? defaultNotificationDelay
        : typeof notification.delay == 'number'
          ? notification.delay
          : delayMap[notification.delay]
    );
  });

  const removeNotification = (id: number): void => {
    setNotifications((prev) => prev.filter((c) => c.id !== id));
  };

  onCleanup(() => {
    off();
  });

  return (
    <Portal>
      <div class="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-notification flex flex-col gap-2 min-w-[320px] max-w-[500px]">
        <For each={notifications}>
          {(notification) => (
            <Alert
              type={notification.type}
              content={notification.message}
              icon={iconMap[notification.type]}
              buttonText={t('general.close')}
              onButtonClick={() => {
                removeNotification(notification.id);
              }}
            />
          )}
        </For>
      </div>
    </Portal>
  );
};

export default Notifications;
